import { differenceInHours, toDate } from 'date-fns';

interface IProps {
  updatedAt: number;
}

export const getVisibleCacheColor = ({updatedAt}: IProps) => {
  const diffInHours = differenceInHours(Date.now(), toDate(updatedAt));

  if(diffInHours <= 1) {
    return '#2e7d32';
  }
  if(diffInHours <= 4) {
    return '#ed6c02';
  }
  return '#d32f2f';
}